import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from 'ng2-translate';

import { LoginComponent } from './login.component';
import { LoginService } from './services/login.service';

import { DomainModule } from '../domain/domain.module';

@NgModule({
  imports: [
    CommonModule,
    DomainModule,
    TranslateModule.forRoot()
  ],
  providers: [
    LoginService
  ],
  declarations: [LoginComponent]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/modules/login/login.module.ts